import { render, staticRenderFns } from "./BrandingPlan.vue?vue&type=template&id=23f1c393&"
import script from "./BrandingPlan.vue?vue&type=script&lang=js&"
export * from "./BrandingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports